import type { JSX } from "react";
import type { AnalyticsDailyStatsRow } from "@/features/analytics/types";
import DataTable, { DATA_TABLE_CLASSES } from "@/components/common/DataTable";

type DailyStatsTableProps = {
  rows: AnalyticsDailyStatsRow[];
};

const formatMetric = (value: number): string =>
  Number(value || 0).toLocaleString("en-US");

export const DailyStatsTable = ({
  rows,
}: DailyStatsTableProps): JSX.Element => {
  const totals = rows.reduce(
    (summary, row) => ({
      total: summary.total + row.total,
      unique: summary.unique + row.unique,
    }),
    { total: 0, unique: 0 },
  );

  return (
    <DataTable>
      <thead>
        <tr className={DATA_TABLE_CLASSES.headRow}>
          <th className={DATA_TABLE_CLASSES.th}>Date</th>
          <th className={DATA_TABLE_CLASSES.th}>Impressions</th>
          <th className={DATA_TABLE_CLASSES.th}>Unique devices</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={3} className={DATA_TABLE_CLASSES.emptyCell}>
              No data for the selected range.
            </td>
          </tr>
        ) : (
          rows.map((row) => (
            <tr key={row.date} className={DATA_TABLE_CLASSES.bodyRow}>
              <td
                className={`${DATA_TABLE_CLASSES.td} text-[13.5px] font-bold text-(--text-primary)`}
              >
                {row.date}
              </td>
              <td
                className={`${DATA_TABLE_CLASSES.td} text-[13.5px] font-bold text-(--text-primary) tabular-nums`}
              >
                {formatMetric(row.total)}
              </td>
              <td
                className={`${DATA_TABLE_CLASSES.td} text-[13.5px] font-bold text-(--text-primary) tabular-nums`}
              >
                {formatMetric(row.unique)}
              </td>
            </tr>
          ))
        )}
      </tbody>
      {rows.length > 0 && (
        <tfoot>
          <tr className="border-t border-(--border-subtle)">
            <td
              className={`${DATA_TABLE_CLASSES.td} text-[13.5px] font-bold text-(--text-primary)`}
            >
              Total
            </td>
            <td
              className={`${DATA_TABLE_CLASSES.td} text-[13.5px] font-bold text-(--text-primary) tabular-nums`}
            >
              {formatMetric(totals.total)}
            </td>
            <td
              className={`${DATA_TABLE_CLASSES.td} text-[13.5px] font-bold text-(--text-primary) tabular-nums`}
            >
              {formatMetric(totals.unique)}
            </td>
          </tr>
        </tfoot>
      )}
    </DataTable>
  );
};
